import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import infoIcon from "icons/info-new-rows.svg";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { deleteWorkspace } from "slices/systemAdmin/actions/systemAdmin";

const DeleteWorkspaceModal = ({ workspaceName, workspaceId }) => {
  const dispatch = useDispatch();

  const handleConfirmation = () => {
    dispatch(deleteWorkspace(workspaceName, workspaceId));
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.DELETE_WORKSPACE));
  };

  const modalBody = () => (
    <div className="delete__workspace__modal">
      <div className="delete__workspace__modal__icon">
        <img src={infoIcon} alt="info icon" />
      </div>
      <div className="delete__workspace__modal__info">
        <p>
          We will delete all data contained in the{" "}
          <b>{workspaceName} Workspace </b>
          (folders, documents, dictionaries and associated analysis). This
          action cannot be undone.
        </p>
        <p>
          Members that only exist in this workspace will be deleted from the
          system completely.
        </p>
      </div>
    </div>
  );

  return (
    <Modal
      data-testid="deleteWorkspaceModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
    >
      <Modal.Header>
        <b>Delete Workspace</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <NewButton
          data-test="cancelButton"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          Cancel
        </NewButton>

        <NewButton
          data-test="saveButton"
          variant={NewButtonVariant.l1}
          onClick={() => {
            handleConfirmation();
          }}
          disabled={false}
        >
          Permanently Delete
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteWorkspaceModal;

DeleteWorkspaceModal.propTypes = {
  workspaceName: PropTypes.string.isRequired,
  workspaceId: PropTypes.number.isRequired,
};
